import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../../../../services/core.user.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'my-reports-header',
  template: require('./myreports.header.component.html')
})
export class MyReportsHeaderComponent implements OnInit {
  @Input() myReports: any;
  @Input() myReport: any;
  @Input() crumbs: any;

  user: any;

  constructor(
    public stateService: StateService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.user = this.userService.session.getUser();
  }

  trackById(index: number, item: any): any {
    return item?.id ?? item;
  }
}
